import { render, staticRenderFns } from "./PostContact.vue?vue&type=template&id=30cb3470"
import script from "./PostContact.vue?vue&type=script&lang=js"
export * from "./PostContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports